import React, { useEffect } from "react";
import { Fancybox } from "@fancyapps/ui";
import Image from "../elements/Image";

const OrderDetailImageGallery = ({ items = [] }) => {
  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      Thumbs: { autoStart: false },
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
            "rotateCCW",
            "rotateCW",
            "flipX",
            "flipY",
          ],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Images: { zoom: true },
      mainClass: "fancybox-custom",
    });

    return () => Fancybox.destroy();
  }, []);

  return (
    <div className="relative bg-white p-4 rounded-lg shadow shadow-md-pink/20">
      <div className="mb-4 text-lg 2xl:text-xl font-semibold text-md-dark">
        Ordered Files ({items.length})
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-4">
        {items.map((item, index) => (
          <a
            key={item._id}
            href={item?.media?.url}
            data-fancybox="gallery"
            data-caption={`Image #${index + 1}`}
            className="block group rounded-lg overflow-hidden border border-slate-100 hover:shadow-lg transition-all duration-300"
          >
            <div className="aspect-square w-full bg-slate-50 relative">
              <Image
                src={item?.media?.url}
                alt={`Item-${index + 1}`}
                classes="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
              />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default OrderDetailImageGallery;
